/* eslint-disable react/destructuring-assignment */
import React, { useState } from 'react'
import styled from 'styled-components'
import { useSpring, animated } from 'react-spring'

const calc = (x, y) => [x - window.innerWidth / 2, y - window.innerHeight / 2]

const trans2 = (x, y) => `translate3d(${x / 4 - 50}px,${y / 6 - 100}px,0)`
const trans3 = (x, y) => `translate3d(${x / 8}px,${y / 6 - 250}px,0)`
const trans1 = (x, y) => `translate3d(${x / 4}px,${y / 3 + 100}px,0)`

const RECTANGLES_COLORS = ['#00FFF0', '#05DA34', '#15BEFF']

const getRandomInt = (min, max) =>
  Math.floor(Math.random() * (max - min + 1) + min)

const isCollide = (a, b) =>
  !(
    a.y + a.height < b.y ||
    a.y > b.y + b.height ||
    a.x + a.width < b.x ||
    a.x > b.x + b.width
  )

const checkOverlap = (rectangles, currentRect) => {
  for (let i = 0; i < rectangles.length; i++) {
    if (isCollide(rectangles[i].props, currentRect)) {
      return true
    }
  }

  return false
}

const generateRectangleDimensions = rectangles => {
  const squareDim = getRandomInt(6, 32)
  const x = getRandomInt(squareDim, 1000 - squareDim)
  const y = getRandomInt(squareDim, 300 - squareDim)

  return { x, y, width: squareDim, height: squareDim }
}

const generateRect = amount => {
  const rectangles = []

  for (let i = 0; i < amount; i++) {
    const newRectangle = generateRectangleDimensions(rectangles)
    const overlapped = checkOverlap(rectangles, newRectangle)

    if (overlapped) {
      i--
      continue
    }

    const color = i % 3
    const rotateAngle = getRandomInt(0, 120)
    const rotate =
      i % 1 === 0
        ? `rotate(${rotateAngle} ${newRectangle.x +
            newRectangle.width / 2} ${newRectangle.y +
            +newRectangle.height / 2})`
        : ``

    rectangles.push(
      <rect
        key={i}
        width={newRectangle.width}
        height={newRectangle.height}
        x={newRectangle.x}
        y={newRectangle.y}
        fill={RECTANGLES_COLORS[color]}
        transform={rotate}
      />
    )
  }

  return rectangles
}

const OnMouseContainer = styled.div`
  ${tw`absolute pin-t pin-x md:m-auto`}
  height: 100%;
`

const Container = styled.div`
  ${tw`absolute pin-y`}
  margin: auto;
  width: 100%;
  max-height: 800px;
`

const SvgParticle = styled.svg`
  ${tw`w-full m-auto`}
  opacity: ${props => (props.opacity ? props.opacity : 0.25)};
  height: 300px;
`

const BgParticles = () => {
  const [props, set] = useSpring(() => ({
    xy: [0, 0],
    config: { mass: 10, tension: 550, friction: 140 },
  }))

  return (
    <OnMouseContainer
      onMouseMove={({ clientX: x, clientY: y }) => set({ xy: calc(x, y) })}
    >
      <Container>
        <animated.div style={{ transform: props.xy.interpolate(trans1) }}>
          <SvgParticle
            viewBox="0 0 1000 300"
            onMouseMove={({ clientX: x, clientY: y }) =>
              set({ xy: calc(x, y) })
            }
            opacity={0.2}
          >
            {generateRect(10)}
          </SvgParticle>
        </animated.div>
        <animated.div style={{ transform: props.xy.interpolate(trans2) }}>
          <SvgParticle viewBox="0 0 1000 300" opacity={0.5}>
            {generateRect(10)}
          </SvgParticle>
        </animated.div>
        <animated.div style={{ transform: props.xy.interpolate(trans3) }}>
          <SvgParticle viewBox="0 0 1000 300" opacity={0.3}>
            {generateRect(10)}
          </SvgParticle>
        </animated.div>
      </Container>
    </OnMouseContainer>
  )
}

export default BgParticles
